<div class="flex flex-col gap-5">
  <div class="flex flex-col gap-4 px-4">
    @if (bureauResponse && bureauResponse.authorization.iS_AUTORIZADO != 'NO HA SIDO AUTORIZADO') {
      <div class="flex justify-between h-[80px]">
        <img src="../../../../assets/images/logo_carvest_chico.png" alt="" />
        <img src="../../../../assets/images/BC.png" alt="" />
      </div>

      <div
        class="py-2 px-4 text-general-subtitle text-white bg-[--brand-azul-primario] w-full rounded-lg"
      >
        {{ bureauResponse ? bureauResponse.client.nombre : '' }}
        {{ bureauResponse ? bureauResponse.client.aP_MATERNO : '' }}
        {{ bureauResponse ? bureauResponse.client.aP_PATERNO : '' }}
      </div>

      @if (dataSource.data.length) {
        <div class="flex flex-col gap-4">
          <div
            class="bg-[--brand-azul-primario] w-full rounded-lg col-span-full py-1 text-white flex justify-center items-center text-base font-medium"
          >
            {{ 'general-pages.bureau-consultation.documentsSummary' | translate }}
          </div>
          <app-table-general-simple
            class="col-span-full"
            [dataSource]="dataSource"
            [headers]="headers"
            (idEmitter)="getPdf($event)"
          ></app-table-general-simple>
        </div>
      }
      <div class="col-span-full flex justify-center items-center">
        <button
          (click)="newQuery()"
          class="bg-primary! rounded-md w-50! h-12.75 text-center justify-center! !m-auto text-white!"
          mat-menu-item
        >
          {{ 'general-pages.bureau-consultation.newQuery' | translate }}
        </button>
      </div>
    } @else {
      @if (bureauResponse) {
        <div
          class="py-2 px-4 text-general-subtitle text-center text-[--brand-azul-primario] w-full rounded-lg"
        >
          {{ 'general-pages.bureau-consultation.notAuthorized' | translate }}
        </div>
      }
    }
  </div>
</div>
